import { Component } from '@angular/core';
import { IonicPage } from 'ionic-angular';


@IonicPage()
@Component({
  selector: 'page-circulars',
  templateUrl: 'circulars.html',
})
export class CircularsPage {

  constructor() { }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CircularsPage');
  }

  goCirculars() {
    window.open('http://www.deltebre.cat/rrhh/circulars.html', '_system', 'location=yes'); return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/circulars/circulars.ts